import React from 'react'
import HelpText from '../../HelpText'

const FEEFREEButton = props => {
  return props.ineligibleForFEEFREEInd === 'Y' ? null : (
    <div className="question-group question-group-divider">
      <HelpText tag="h3" text="FEE-FREE Uni Ready (Commonwealth Supported) place" />

      <div className="financial-content">
        <p>You have been offered a Commonwealth supported place (CSP) in a FEE-FREE Uni Ready course of study and the Australian Government pays a Commonwealth contribution for your CSP directly to Victoria University.</p>
        <p>
          You will not be charged a tuition fee for your FEE-FREE Uni Ready course of study.
        </p>
        <p>
          To accept your Commonwealth supported place you need to complete an electronic Commonwealth assistance form and provide a valid <a href="https://www.studyassist.gov.au/help-loans/your-usi-chessn">USI</a> before the first <a href="https://www.vu.edu.au/current-students/your-course/fees/higher-education-fees/higher-education-census-payment-deadlines" target="_blank">census date</a>.
        </p>
        <p>
          After you have pressed the below "Accept your FEE-FREE Uni Ready CSP" button you will receive an email to your nominated preferred email account within 24 hours.
        </p>
        <p>
          <a className={`btn btn-financial-margin btn-financial-medium btn-primary center ${props.isHelpSubmitted === 'Y' ? 'disabled-link' : ''}`} href={props.link}>
             Accept your FEE-FREE Uni Ready CSP
          </a>
        </p>
      </div>
    </div>
  )
}

export default FEEFREEButton
